import {
    Outlet,

} from "react-router-dom"

import Header from "../Pages/Header";
import Home from "../Pages/Home";

const HomeLayout = () => {
    return (
        <div className="w-full h-[90px] ">
            {/* <Header /> */}
             {/* <Home />  */}
             <Outlet /> 
        </div>

    );
}
export default HomeLayout